module.exports = __webpack_public_path__ + "img/user.f4bd1101.svg";